import styled, { createGlobalStyle, DefaultTheme } from 'styled-components';
import reset from 'styled-reset';

export const theme: DefaultTheme = {
  primaryColor: '#1B84A2',
  darkPrimaryColor: '#0054A2',
  primaryTransparent: 'rgba(27, 132, 162, 0.8)',
  secondaryColor: '#FF6464',
  primaryBgColor: '#05191F',
  primaryTextColor: '#146076',
  warningTextColor: '#FF5239',
  fontColorTitle: '#000',
  fontColorContent: '#3A3B3E',
  fontColorFooter: '#5F6165',
  fontColorSubContent: '#9FA1A7',
  secondaryBgColor: '#F2F2F2',
  mobile: '(max-width: 520px)',
  desktop: '(min-width: 520px)',
  ktpPrimary10: '#E9F0FE',
  ktpPrimary100: '#246CF6',
  ktpPrimary150: '#1856CD',
};

export const GlobalStyle = createGlobalStyle`
    ${reset};

    * {
        box-sizing: border-box;
        font-family: 'Pretendard', sans-serif;
      }
    body {
      font-size: 16px;
      background-color: #fff;
      font-family: 'Pretendard', sans-serif;
      font-weight: 500; 
      ::-webkit-scrollbar {
      display: none;
      }
      -ms-overflow-style: none; /* 인터넷 익스플로러 */
      scrollbar-width: none; /* 파이어폭스 */
    }
    button{
      border:none;
      cursor:pointer;
      background-color:transparent;
      padding: 0;
      :hover{
        opacity:0.8;
      }
      transition:200ms all ease-in;
    }
    a {
      text-decoration: none;
      color: ${(props) => props.theme.fontColorTitle};
    }
    input{
      outline:none;
    }
    h1,h2,h3,h4,span,p,button{
      color: #000000;
    }
    .skiptranslate.goog-te-gadget {
     color: transparent;
     & span{
       display:none;
     }
    }
    select{
      padding: 4px 12px;
      width: 140px;
      border-radius: 2px;
      outline:none;
      background-color:#ffffff;
      color: #000000;
      @media ${(props) => props.theme.mobile} {
        padding: 2px 10px;
      }
    }
    body{
      top:0 !important;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    .VIpgJd-suEOdc.VIpgJd-yAWNEb-L7lbkb.skiptranslate{
      display:none !important;
    }
    .react-calendar__navigation {
      display: flex;
      margin-bottom: 1rem;
    }
    .react-calendar__navigation__arrow {
      width: 44px;
      height: 44px;
    }
    .react-calendar__month-view__weekdays__weekday {
      text-align: center;
    }
    .react-calendar__month-view__days__day--weekend {
      color: #d10000;
    }
    .react-calendar__tile--active {
      background: #006edc;
    }
    .react-calendar__tile:disabled {
      background: #f0f0f0;
    }
    @media print {
    .print-page {
      size: landscape;
    }
  }
`;

export const TranslationZone = styled.div`
  height: 40px;
  background: #f1f1f1;
  @media screen and (max-width: 520px) {
    height: 32px;
  }
`;
